import { jsx, jsxs } from "react/jsx-runtime";
import { Slider, XStack } from "tamagui";
function SliderDemo() {
  return /* @__PURE__ */ jsxs(XStack, { height: 200, alignItems: "center", space: "$8", children: [
    /* @__PURE__ */ jsx(SimpleSlider, { height: 200, orientation: "vertical" }),
    /* @__PURE__ */ jsx(SimpleSlider, { width: 200 })
  ] });
}
function SimpleSlider({ children, ...props }) {
  return /* @__PURE__ */ jsxs(Slider, { defaultValue: [50], max: 100, step: 1, ...props, children: [
    /* @__PURE__ */ jsx(Slider.Track, { children: /* @__PURE__ */ jsx(Slider.TrackActive, {}) }),
    /* @__PURE__ */ jsx(Slider.Thumb, { index: 0, circular: true, elevate: true }),
    children
  ] });
}
export {
  SliderDemo
};
//# sourceMappingURL=SliderDemo.js.map
